import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);
let counter = 1;

const routes = [
  {
    path: '/',
    name: 'Index',
    component: () => import('../views/Index'),
    redirect: { name: 'ReceipesRegular' },
    meta: { requiresAuth: true },
    children: [
      {
        path: 'regular/:id?',
        name: 'ReceipesRegular',
        component: () => import('../views/ReceipesRegular'),
      },
      {
        path: 'special/:id?',
        name: 'ReceipesSpecial',
        component: () => import('../views/ReceipesSpecial'),
        meta: {
          recipeSetType: 'special'
        }
      },
      {
        path: 'partner/:id?',
        name: 'ReceipesSpecialPartner',
        component: () => import('../views/ReceipesSpecial'),
        meta: {
          recipeSetType: 'partner'
        }
      },
      {
        path: 'plans',
        name: 'ReceipesPlans',
        component: () => import('../views/ReceipesPlans')
      },
      {
        path: 'test',
        name: 'ReceipesTest',
        component: () => import('../views/ReceipesTest')
      },
    ]
  },
  {
    path: '/subscribes',
    name: 'UserSubscribes',
    component: () => import('../views/UserSubscribes'),
  },
  /*
  {
    path: '/recipe/:id?',
    name: 'ReceipesDetail',
    component: () => import('../views/ReceipesDetail'),
    meta: { requiresAuth: true }
  },
  */
  {
    path: '/login',
    name: 'AuthLogin',
    component: () => import('../views/AuthLogin'),
    meta: { hideLeftBar: true, skipRouteData: true },
  },
  {
    path: '/registration',
    name: 'Registration',
    component: () => import('../views/AuthRegistration'),
    meta: { hideLeftBar: true, skipRouteData: true },
  },
  {
    path: '/purchases',
    name: 'PurchasesMain',
    component: () => import('../views/PurchasesMain'),
    meta: { requiresAuth: true }
  },
  {
    path: '/diary',
    name: 'DiaryMain',
    component: () => import('../views/Diary'),
    meta: { requiresAuth: true },
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import('../views/Search'),
    meta: { requiresAuth: true },
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('../views/Settings'),
    meta: { requiresAuth: true, skipRouteData: true },
  },
  {
    path: '/onboarding',
    name: 'Onboarding',
    component: () => import('../views/OnboardingIndex'),
    props: { maxTabs: 7, tabIndex: 0},  /// set max number of tabs, @see OnboardingIndex::links
    meta: { requiresAuth: true, hideLeftBar: true, resetLocalStorage: true, skipRouteData: true },
    redirect: ({ name: 'OnboardingGender' }),
    children: [
      {
        path: 'gender',
        name: 'OnboardingGender',
        component: () => import('../views/OnboardingGender'),
        meta: { tabIndex: counter++ },
      },
      {
        path: 'birthday',
        name: 'OnboardingBirthday',
        component: () => import('../views/OnboardingBirthday'),
        meta: { tabIndex: counter++ },
      },
      {
        path: 'height',
        name: 'OnboardingHeight',
        component: () => import('../views/OnboardingHeight'),
        meta: { tabIndex: counter++ }
      },
      {
        path: 'weight',
        name: 'OnboardingWeight',
        component: () => import('../views/OnboardingWeight'),
        meta: { tabIndex: counter++ }
      },
      {
        path: 'activity',
        name: 'OnboardingActivity',
        component: () => import('../views/OnboardingActivity'),
        meta: { tabIndex: counter++ }
      },
      {
        path: 'goals',
        name: 'OnboardingGoals',
        component: () => import('../views/OnboardingGoals'),
        meta: { tabIndex: counter++ }
      },
      {
        path: 'result',
        name: 'OnboardingResult',
        component: () => import('../views/OnboardingResult'),
        meta: { tabIndex: counter++ },
      },
    ]
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../views/UserProfile'),
    meta: { requiresAuth: true }
  }
];

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (to.name === from.name) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  }
});

const ROUTE_DATA_KEY = 'route-data';
let isFirstTransition = true;

function forgetLastRoute() {
  try { window.localStorage.removeItem(ROUTE_DATA_KEY); } catch (_) { /* Route hints are optional. */ }
}

function getLastRouteFullPath() {
  try {
    const routeData = JSON.parse(window.localStorage.getItem(ROUTE_DATA_KEY));
    const fullPath = routeData && routeData.fullPath;

    if (
      typeof fullPath !== 'string' ||
      !fullPath.startsWith('/') ||
      fullPath.startsWith('//') ||
      !router.resolve(fullPath).route.matched.length
    ) {
      forgetLastRoute();
      return null;
    }

    return fullPath;
  } catch (e) {
    console.error(e);
    forgetLastRoute();
    return null;
  }
}

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.resetLocalStorage)) {
    forgetLastRoute();
    window.localStorage.removeItem('auth-data');
    window.localStorage.removeItem('search-data');
    window.localStorage.removeItem('search-params');
  }

  if (!isFirstTransition) {
    next();
    return;
  }
  isFirstTransition = false;

  if (to.matched.some(record => record.meta.skipRouteData)) {
    next();
    return;
  }

  if (from.matched.some(record => record.meta.skipRouteData)) {
    next();
    return;
  }

  const isRootEntry = (
    window.location.pathname === '/' &&
    !window.location.search &&
    !window.location.hash
  );
  if (!isRootEntry) {
    next();
    return;
  }

  try {
    const authData = window.localStorage.getItem('auth-data');
    if (!authData) {
      next();
      return;
    }
    if (!JSON.parse(authData).isAuth) {
      next();
      return;
    }
  } catch (e) {
    console.error(e);
    next();
    return;
  }

  const lastRouteFullPath = getLastRouteFullPath();
  if (lastRouteFullPath && lastRouteFullPath !== to.fullPath) {
    next({ path: lastRouteFullPath, replace: true });
    return;
  }

  next();
});

router.afterEach(to => {
  if (to.matched.some(record => record.meta.skipRouteData)) {
    return;
  }

  try {
    localStorage.setItem(ROUTE_DATA_KEY, JSON.stringify({ fullPath: to.fullPath }));
  } catch (_) { /* Optional cache must not block authenticated navigation. */ }
});

export default router;
